export default __webpack_public_path__ + "static/media/paperOS_capital_at_scale_brown_md.7914a0d2.png";